export const settingsLanguage = {
        ES:{id:1,name:"Español", shortName:"ES", file:"es.js", flagCode:"es", selected:false},
        EN:{id:2,name:"English", shortName:"EN", file:"en.js", flagCode:"gb", selected:false},
        IT:{id:3,name:"Italiano", shortName:"IT", file:"it.js", flagCode:"it", selected:false},
        AR:{id:4,name:"العربية", shortName:"AR", file:"ar.js", flagCode:"sa", selected:false}
    };